import React from "react";

interface CharityEvent {
  id: number;
  title: string;
  date: string;
  location: string;
  description: string;
  link: string;
}

const PhilanthropyPage: React.FC = () => {
  const charityEvents: CharityEvent[] = [
    {
      id: 1,
      title: "Celebrity Auction for Education",
      date: "January 15, 2024",
      location: "Virtual Event",
      description:
        "Join our online auction where celebrities donate personal items or experiences to raise funds for underprivileged students' education.",
      link: "https://example.com/charity-auction",
    },
    {
      id: 2,
      title: "Fan1 Clean-Up Drive",
      date: "March 10, 2024",
      location: "Los Angeles, CA",
      description:
        "Participate with your favorite celebrities in a community clean-up drive to make our neighborhoods greener and cleaner.",
      link: "https://example.com/cleanup-drive",
    },
    {
      id: 3,
      title: "Concert for a Cause",
      date: "April 22, 2024",
      location: "New York City, NY",
      description:
        "Attend a star-studded concert where all proceeds will go toward disaster relief efforts across the globe.",
      link: "https://example.com/concert-for-cause",
    },
  ];

  return (
    <div className="container px-5">
      <div className="philanthropy-page">
        <h1>Philanthropy at Fan1</h1>
        <p>
          At Fan1, we believe in the power of fans and celebrities to make a
          difference in the world. Our philanthropy initiatives connect fans and
          celebrities through impactful charitable events and campaigns.
        </p>

        <div
          className="charity-events-grid"
        >
          {charityEvents.map((event) => (
            <div
              key={event.id}
              className="charity-card"
            >
              <h2>{event.title}</h2>
              <p>
                <strong>Date:</strong> {event.date}
              </p>
              <p>
                <strong>Location:</strong> {event.location}
              </p>
              <p>{event.description}</p>
              <a
                href="*"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PhilanthropyPage;
